var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgEl6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8806 0L63.2622 31.6833L100 42.1578L68.4046 63.35L58.1196 100L36.7379 68.3167L0 57.8423L31.5956 36.6501L41.8806 0Z",
    fill: "#F5F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgEl6);
export default __webpack_public_path__ + "static/media/bg-el-6.c276f64505d25aa09626d44d5014a11a.svg";
export { ForwardRef as ReactComponent };